export { default } from './CollapsiblePatientCardSection';
